import React from 'react';
import { ShimmerLoader } from '@guildeducationinc/recess';
import Carousel from '@shared/Carousel/Carousel';
import { useEmployerContent } from '@src/context/EmployerContentContext';
import { ComponentDataKey } from '@pages/Home/Layout/config';
import ErrorMessage from '@shared/ErrorMessage/ErrorMessage';
import { useMemberTraitsContext } from '@src/context/MemberTraitsContext';
import { CardContent } from '@src/components/Shared/interfaces/CardContent';

interface ExploreCards {
  [key: string]: CardContent;
}

export interface ExploreProps {
  analyticsId?: string;
}

const Explore: React.FC<ExploreProps> = ({ analyticsId }) => {
  const dataKey = ComponentDataKey.LEARN_SKILLS;

  const { loading: memberTraitsLoading, memberTraits } = useMemberTraitsContext();

  const { [dataKey]: content, error: contentError, loading: contentLoading } = useEmployerContent();

  const cardsContent = content?.tabs?.explore_tab?.cards;

  const exploreCards: ExploreCards = {};

  if (cardsContent && memberTraits) {
    if (memberTraits?.hasQuizRecommendations) {
      exploreCards.view_quiz_results = {
        ...cardsContent.view_quiz_results,
        key: 'view_quiz_results',
      };
    } else {
      exploreCards.find_programs = {
        ...cardsContent.find_programs,
        key: 'find_programs',
      };
    }

    exploreCards.view_programs = {
      ...cardsContent.view_programs,
      key: 'view_programs',
    };
  }

  const cards = Object.values(exploreCards);

  if (contentError || content?.error) {
    return <ErrorMessage />;
  }

  return (
    <ShimmerLoader label='explore-cards' loaded={!contentLoading && !memberTraitsLoading}>
      <Carousel analyticsId={analyticsId} cards={cards} />
    </ShimmerLoader>
  );
};

export default Explore;
